import Vue from 'vue';
import Router from 'vue-router';
import Home from '../components/views/Home.vue';
const ProphyResults = () => import('../components/views/ProphyResults.vue');
const BaselineProphyPage = () => import('../components/views/BaselineProphyPage');
const Questionnaire = () => import('../components/views/Questionnaire');
const GroupTab = () => import('../components/views/GroupTab.vue');
const Results = () => import('../components/views/Results.vue');
const QuestionnaireThankYou = () => import('../components/views/QuestionnaireThankYou.vue');

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      props: true
    },
    {
      path: '/results/:formId',
      name: 'Results',
      component: Results
    },
    {
      path: '/group',
      name: 'Group',
      component: GroupTab
    },
    {
      path: '/questionnaire/:formId',
      name: 'Questionnaire',
      component: Questionnaire
    },
    {
      path: '/thankyou/:formId',
      name: 'QuestionnaireThankYou',
      component: QuestionnaireThankYou
    },
    {
      path: '/recurringresults/:study/:month',
      name: 'RecurringResults',
      component: ProphyResults,
      props: true
    },
    {
      path: '/baselineprophy',
      name: 'BaselineProphyPage',
      component: BaselineProphyPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js